import { create } from 'zustand';

type TTimeKeepingState = {
  recordsCount: number;
  setRecordsCount: (count: number) => void;
  activeSessionId: string | undefined;
  setActiveSessionId: (id: string | undefined) => void;
};

export const useTimeKeepingStore = create<TTimeKeepingState>(set => ({
  recordsCount: 0,
  setRecordsCount: count => set({ recordsCount: count }),
  activeSessionId: undefined,
  setActiveSessionId: id => set({ activeSessionId: id }),
}));
